import type { ActiveGamesState } from '../../types';

export const reducers = {
  setGames: (
    state: ActiveGamesState,
    payload: ActiveGamesState['games'] = []
  ): ActiveGamesState => ({
    ...state,
    games: payload
  })
};
